import { render, staticRenderFns } from "./ProjectHomeOne.vue?vue&type=template&id=4867150a"
import script from "./ProjectHomeOne.vue?vue&type=script&lang=js"
export * from "./ProjectHomeOne.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports